import React from 'react'

const Furniture = () => {
  return (
    <div>
          <h1>clothing</h1>
      
    </div>
  )
}

export default Furniture
